import { postApi } from '../api/digitalVault';
const getFileByChecksums = async ({ checksumAndRepositoryNames, showDeleted, latest }, logger) => {
    const urlParams = new URLSearchParams();
    showDeleted && urlParams.append('showDeleted', showDeleted.toString());
    latest && urlParams.append('latest', latest.toString());
    const body = {
        checksumsAndRepositoryNames: {
            '@xmlns': {
                dvi: 'http://internal.dv.newbay.com/ns/1.0',
                $: 'http://dv.newbay.com/ns/1.0',
                a: 'http://alternate.newbay.com/ns/1.0',
            },
            checksumAndRepositoryNames,
        },
    };
    const response = await postApi(body, `file/checksum`, {}, logger);
    return response;
};
export default getFileByChecksums;
